// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/pictures/solea-logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-hg-color: #824bb0;
  --main-light-hg-color: #b48dd4;
  --main-very-light-hg-color: #f6edfd;
  --main-txt-secondary: #C5C5C5;
  --main-txt-primary: #4D4B48;
  --main-link-color: #BBB;
  --main-link-color-hover: #AAA;
  --footer-selected-color: #3C3C3B;
  --footer-separator-color: #DEDEDE;
  --background-color: #EEE;
  --main-width: 370px;
  --inputPadding: 1em;
  --buttonPadding: 1em;
}

body {
    background: #f7fbfd;
}
h1 {
    font-weight:bold;
    text-align:center;
}
h1,h2,h3,h4,h5 {
    font-family: OpenSans !important;
}


p {
    font-size: 1.1em;
    font-weight: 300;
    line-height: 1.7em;
    font-family: OpenSans;
}

a,
a:hover,
a:focus {
    color: inherit;
    text-decoration: none;
    font-family: OpenSans;
}

i,
span {
    display: inline-block;
    font-family: OpenSans;
}

strong {
    font-family: OpenSans;
}

button {
    font-family: OpenSans;
}

label {
    font-family: OpenSans;
}

div {
    font-family: OpenSans;
}



a.labelDebug {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline !important;
}

.btncancel {
    margin-left: 18px;
}


:root {
    --main-hg-color: #824bb0;
    --main-light-hg-color: #b48dd4;
    --main-very-light-hg-color: #f6edfd;
    --main-txt-secondary: #C5C5C5;
    --main-txt-primary: #4D4B48;
    --main-link-color: #BBB;
    --main-link-color-hover: #AAA;
    --footer-selected-color: #3C3C3B;
    --footer-separator-color: #DEDEDE;
    --background-color: #EEE;
    --main-width: 370px;
    --inputPadding: 1em;
    --buttonPadding: 1em;
  }
  
  * {
    box-sizing: border-box;
  }
  
  html {
    overflow-x: hidden;
    height: 100%;
  }
  
  body {
    height: 100%;
    overflow-x: hidden;
  }
  
  body {
    margin: 0;
    line-height: 1.35em;
    color: var(--main-txt-primary);
    font-family: Campton,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  /*
  #root {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
  }
  #root > div:not(#footer) {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .footerHeight {
    height: calc(100% - 90px);
  
  }
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  */
  #headerLogo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 19.03px;
    width: calc(100vw / 3);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: auto;
    margin-right: auto;
    margin-top: 150px;
    transform: scale(10);
  }
  /*
  #footer {
    position: fixed;
    z-index: 999;
    bottom: 0px;
    width: var(--main-width);
    left: 0;
    width: 100vw;
    font-size: 8px;
    background: #fff;
    height: 79px;
  }
  #footer .footerTitle {
    margin-top: 5px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
  }
  #footer .footerPicto {
    background-color: var(--main-link-color);
    height: 22px;
    width: 22px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: auto;
    margin-right: auto;
    mask-size: 100%;
    -webkit-mask-size: 100%;
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
  }
  #footer .selected .footerPicto {
    background-color: var(--footer-selected-color);
  }
  
  #footer .selected .footerTitle {
    color: var(--footer-selected-color);
  }
  
  #footer .footerItemContainer {
    width:100%;
  }
  #footer .footerItemContainer > div  {
    position: relative;
  }
  #footerWallet .footerHome {
    background-image: url("../res/logo.svg");
  }
  
  #footerStore {
    
  }
  
  #footerInfo {
    
  }
  
  #footerNewCount {
    position: absolute;
    background-color: var(--main-hg-color);
    border-radius: 100%;
    width: 10px;
    height: 10px;
    left: 50%;
    transform: translateX(calc(-50% + 7px));
    top: 17px;
    border: solid 1px #fff;
  }
  
  #footerProfile {
    
  }
  */
  #header .absoluteTitle {
    font-family: Campton,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;;
    font-size: 55px;
    font-weight: 400;
    color: var(--main-hg-color);
  }
  /*
  #content {
    text-align: left;
    z-index: 5;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-bottom: 20px;
    flex-grow: 1;
    overflow-y: auto;
    max-height: 80vh;
    padding-left: 25px;
    padding-right: 25px;
    overflow-x: hidden;
  }
  #content:after {
    content: var(--version);
    color: #ddd;
    font-size: 10px;
    font-weight: 400;
    text-align: right;
  }
  
  .footerHeight #content {
    max-height: 67vh;
  }*/
  
  .button {
    background-color: var(--main-hg-color) !important;
    color:white !important;
    width: 100%;
    border: none;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 20px;
    padding: var(--buttonPadding);
    cursor: pointer;
    display: block;
  }
  
  .button:disabled {
    opacity: 0.5;
  }
  
  .button svg {
    margin-left: 5px;
  }
  
  .chevronBack {
    margin-right: 10px;
  }
  
  a {
    text-decoration: none;
  }
  /*
  a:not(.button) {
    color: var(--main-link-color);
  }
  */
  
  a.button {
    color: inherit;
    text-align: center;
  }
  
  a:hover {
    color: var(--main-link-color-hover);
  }
  
  #footer:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: var(--main-hg-color);
    left: 0;
    top: 0;
  }
  /*
  #footer .footerItemContainer {
    display: flex;
    justify-content: space-evenly;
  }
  
  #footer .footerItemContainer > div {
    padding: 20px 15px 0;
  }
  
  #footer .footerItemContainer .selected {
    position: relative;
  }
  #footer .footerItemContainer .selected{
    background-color : unset;
  }
  #footer .footerItemContainer .selected:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: var(--main-hg-color);
    left: 0;
    bottom: 0;
  }
  
  
  body #footer .tiret {
    content: '';
    position: absolute;
    width: 100%;
    padding: 0;
    height: 1px;
    background-color: var(--main-hg-color);
    left: 0;
    top: 0;
  }
  
  form {
    font-size: 12px;
    display: flex;
    flex-direction: column;
  }
  */
  form > *:not(:last-child) {
    margin-bottom: 10px;
  }
  
  input {
    width: 100%;
    border: solid 1px var(--main-hg-color);
    padding: var(--inputPadding);
    font-weight: bold;
  }
  
  select {
    width: 100%;
    border: solid 1px var(--main-hg-color);
    padding: var(--inputPadding);
    font-weight: bold;
  }
  
  .textPR {
    padding-right: 80px;
  }
  
  .backLink {
    letter-spacing: 1px;
    position: absolute;
    top: 25px !important;
    z-index: 9999;
    font-weight: bold;
    color: var(--footer-selected-color) !important;
    text-transform: uppercase;
    font-size: 10px;
    left: 25px;
  }
  
  body form .labelInput {
    color: #BBBBBB;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .buttonFormLast {
    font-size: 12px;
    width: 100%;
    text-align: center;
    color: #BBBBBB;
    font-weight: bold;
    display: block;
    margin-top: 13px;
  }
  
  body #content .btnReverse {
     min-height: 40px;
     color: var(--footer-selected-color);
     font-size: 12px;
     letter-spacing: 1.2px;
     font-weight: bold;
     display: flex;
     justify-content: center;
     width: 100%;
     padding: 0;
     font-family: 'Clother';
     align-items: center;
  }
  
  .buttonsubmit {
    font-family: 'Clother';
    background: rgb(255, 158, 23) !important;
    color: white !important;
  }
  
  body #content .buttonsubmit svg {
    margin-top: -4px;
  }
  
  .btnBo{
    background: rgb(255, 158, 23);
    color: white;
    width: 200px;
  }
  .btnBo:hover{
    color: white;
    background: var(--main-hg-color);
  }
  
  .buttonsubmit:hover{
    color: white;
  }
  .titleHead {
    font-family: inherit;
    font-weight: 300;
    color: var(--main-link-color);
    padding-top: 70px;
    top: 0;
    z-index: 10;
    right: 0;
    width: 100vw;
    animation-duration: 0.30s;
    animation-name: slideinHead;
    background: white;
    max-width: calc(100vw - 50px);
    margin: 0 auto;
  
  }
  /*
  .walletPagereverseAnim {
    left: 25px !important;
  }
  
  @keyframes slideinHead {
    from {
      width: 0;
    }
  
    to {
      width: 100vw;
    }
  }
  
  
  body .Wallet {
    padding-top: 23px;
  }
  
  .titleHead:after {
    content: '';
    width: 100vw;
    left: 0;
    bottom: 0;
    height: 30px;
    background: linear-gradient(to bottom,rgba(255,255,255,0.1),rgba(255,255,255,0));
    position: absolute;
  }
  
  
  .container__list {
    list-style: none;
    margin: 0;
    padding: 0;
    width: -webkit-fill-available;
  }
  
  .container__list li {
    list-style: none;
    margin: inherit;
    padding: 21px 0;
    justify-content: space-between;
    display: flex;
    border-bottom: 0.5px solid var(--footer-separator-color);
    align-items: center;
    min-height: 64.59px;
    position: relative;
  }
  
  .container__list li:last-child {
    border: initial;
    margin-bottom: 29px;
  }
  
  .container__list li a {
    color: var(--footer-selected-color);
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: 0.65px;
    display: flex;
    align-items: center;
    top: 0;
    right: -25px;
    bottom: 0;
    left: -25px;
    width: 100%;
  }
  
  .productHeader {
    padding-top: 0 !important;
  }
  
  
  body {
    overflow-y: hidden;
  }
  
  .btnReverse {
    background:white !important;
    color: var(--main-hg-color) !important;
    border: 1px solid var(--main-hg-color);
  }
  
  .inputError {
    border: solid 1px red;
    box-shadow: 0px 0px 5px 2px rgba(255, 0, 0, 0.6);
  }
  
  
  @media screen and (-webkit-min-device-pixel-ratio:0) and (max-device-width:1024px) {
    input[type="color"],
    input[type="date"],
    input[type="datetime"],
    input[type="datetime-local"],
    input[type="email"],
    input[type="month"],
    input[type="number"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="text"],
    input[type="time"],
    input[type="url"],
    input[type="week"],
    select:focus,
    textarea {
      font-size: 16px;
    }
  }
  
  .longLabel {
    display: block;
  }
  .shortLabel {
    display: none;
  }
  
  
  @media only screen and (max-width: 800px) {
    .longLabel {
      display: none;
    }
    .shortLabel {
      display: block;
    }
  }
  
  */`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gCAAgC;AACpC;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;;AAIA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mCAAmC;IACnC,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,gCAAgC;IAChC,iCAAiC;IACjC,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,yGAAyG;IACzG,mCAAmC;IACnC,kCAAkC;EACpC;EACA;;;;;;;;;;;;;;;;;;;;;;;;GAwBC;EACD;IACE,yDAA6D;IAC7D,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwEC;EACD;IACE,yGAAyG;IACzG,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;;;;;;;;;;;;;;;;;;;;;;;;;IAyBE;;EAEF;IACE,iDAAiD;IACjD,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;EACA;;;;GAIC;;EAED;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sCAAsC;IACtC,OAAO;IACP,MAAM;EACR;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2CC;EACD;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,sCAAsC;IACtC,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,sCAAsC;IACtC,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,8CAA8C;IAC9C,yBAAyB;IACzB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;KACG,gBAAgB;KAChB,mCAAmC;KACnC,eAAe;KACf,qBAAqB;KACrB,iBAAiB;KACjB,aAAa;KACb,uBAAuB;KACvB,WAAW;KACX,UAAU;KACV,sBAAsB;KACtB,mBAAmB;EACtB;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,MAAM;IACN,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;;EAEhB;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgIC","sourcesContent":[":root {\n  --main-hg-color: #824bb0;\n  --main-light-hg-color: #b48dd4;\n  --main-very-light-hg-color: #f6edfd;\n  --main-txt-secondary: #C5C5C5;\n  --main-txt-primary: #4D4B48;\n  --main-link-color: #BBB;\n  --main-link-color-hover: #AAA;\n  --footer-selected-color: #3C3C3B;\n  --footer-separator-color: #DEDEDE;\n  --background-color: #EEE;\n  --main-width: 370px;\n  --inputPadding: 1em;\n  --buttonPadding: 1em;\n}\n\nbody {\n    background: #f7fbfd;\n}\nh1 {\n    font-weight:bold;\n    text-align:center;\n}\nh1,h2,h3,h4,h5 {\n    font-family: OpenSans !important;\n}\n\n\np {\n    font-size: 1.1em;\n    font-weight: 300;\n    line-height: 1.7em;\n    font-family: OpenSans;\n}\n\na,\na:hover,\na:focus {\n    color: inherit;\n    text-decoration: none;\n    font-family: OpenSans;\n}\n\ni,\nspan {\n    display: inline-block;\n    font-family: OpenSans;\n}\n\nstrong {\n    font-family: OpenSans;\n}\n\nbutton {\n    font-family: OpenSans;\n}\n\nlabel {\n    font-family: OpenSans;\n}\n\ndiv {\n    font-family: OpenSans;\n}\n\n\n\na.labelDebug {\n    cursor: pointer;\n    font-weight: bold;\n    text-decoration: underline !important;\n}\n\n.btncancel {\n    margin-left: 18px;\n}\n\n\n:root {\n    --main-hg-color: #824bb0;\n    --main-light-hg-color: #b48dd4;\n    --main-very-light-hg-color: #f6edfd;\n    --main-txt-secondary: #C5C5C5;\n    --main-txt-primary: #4D4B48;\n    --main-link-color: #BBB;\n    --main-link-color-hover: #AAA;\n    --footer-selected-color: #3C3C3B;\n    --footer-separator-color: #DEDEDE;\n    --background-color: #EEE;\n    --main-width: 370px;\n    --inputPadding: 1em;\n    --buttonPadding: 1em;\n  }\n  \n  * {\n    box-sizing: border-box;\n  }\n  \n  html {\n    overflow-x: hidden;\n    height: 100%;\n  }\n  \n  body {\n    height: 100%;\n    overflow-x: hidden;\n  }\n  \n  body {\n    margin: 0;\n    line-height: 1.35em;\n    color: var(--main-txt-primary);\n    font-family: Campton,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  /*\n  #root {\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    display: flex;\n    flex-direction: column;\n  }\n  #root > div:not(#footer) {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  .footerHeight {\n    height: calc(100% - 90px);\n  \n  }\n  \n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n      monospace;\n  }\n  */\n  #headerLogo {\n    background-image: url(\"../../public/pictures/solea-logo.svg\");\n    height: 19.03px;\n    width: calc(100vw / 3);\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 150px;\n    transform: scale(10);\n  }\n  /*\n  #footer {\n    position: fixed;\n    z-index: 999;\n    bottom: 0px;\n    width: var(--main-width);\n    left: 0;\n    width: 100vw;\n    font-size: 8px;\n    background: #fff;\n    height: 79px;\n  }\n  #footer .footerTitle {\n    margin-top: 5px;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n  }\n  #footer .footerPicto {\n    background-color: var(--main-link-color);\n    height: 22px;\n    width: 22px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin-left: auto;\n    margin-right: auto;\n    mask-size: 100%;\n    -webkit-mask-size: 100%;\n    mask-repeat: no-repeat;\n    -webkit-mask-repeat: no-repeat;\n  }\n  #footer .selected .footerPicto {\n    background-color: var(--footer-selected-color);\n  }\n  \n  #footer .selected .footerTitle {\n    color: var(--footer-selected-color);\n  }\n  \n  #footer .footerItemContainer {\n    width:100%;\n  }\n  #footer .footerItemContainer > div  {\n    position: relative;\n  }\n  #footerWallet .footerHome {\n    background-image: url(\"../res/logo.svg\");\n  }\n  \n  #footerStore {\n    \n  }\n  \n  #footerInfo {\n    \n  }\n  \n  #footerNewCount {\n    position: absolute;\n    background-color: var(--main-hg-color);\n    border-radius: 100%;\n    width: 10px;\n    height: 10px;\n    left: 50%;\n    transform: translateX(calc(-50% + 7px));\n    top: 17px;\n    border: solid 1px #fff;\n  }\n  \n  #footerProfile {\n    \n  }\n  */\n  #header .absoluteTitle {\n    font-family: Campton,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif;;\n    font-size: 55px;\n    font-weight: 400;\n    color: var(--main-hg-color);\n  }\n  /*\n  #content {\n    text-align: left;\n    z-index: 5;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding-bottom: 20px;\n    flex-grow: 1;\n    overflow-y: auto;\n    max-height: 80vh;\n    padding-left: 25px;\n    padding-right: 25px;\n    overflow-x: hidden;\n  }\n  #content:after {\n    content: var(--version);\n    color: #ddd;\n    font-size: 10px;\n    font-weight: 400;\n    text-align: right;\n  }\n  \n  .footerHeight #content {\n    max-height: 67vh;\n  }*/\n  \n  .button {\n    background-color: var(--main-hg-color) !important;\n    color:white !important;\n    width: 100%;\n    border: none;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n    margin-top: 20px;\n    padding: var(--buttonPadding);\n    cursor: pointer;\n    display: block;\n  }\n  \n  .button:disabled {\n    opacity: 0.5;\n  }\n  \n  .button svg {\n    margin-left: 5px;\n  }\n  \n  .chevronBack {\n    margin-right: 10px;\n  }\n  \n  a {\n    text-decoration: none;\n  }\n  /*\n  a:not(.button) {\n    color: var(--main-link-color);\n  }\n  */\n  \n  a.button {\n    color: inherit;\n    text-align: center;\n  }\n  \n  a:hover {\n    color: var(--main-link-color-hover);\n  }\n  \n  #footer:before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    background-color: var(--main-hg-color);\n    left: 0;\n    top: 0;\n  }\n  /*\n  #footer .footerItemContainer {\n    display: flex;\n    justify-content: space-evenly;\n  }\n  \n  #footer .footerItemContainer > div {\n    padding: 20px 15px 0;\n  }\n  \n  #footer .footerItemContainer .selected {\n    position: relative;\n  }\n  #footer .footerItemContainer .selected{\n    background-color : unset;\n  }\n  #footer .footerItemContainer .selected:before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    background-color: var(--main-hg-color);\n    left: 0;\n    bottom: 0;\n  }\n  \n  \n  body #footer .tiret {\n    content: '';\n    position: absolute;\n    width: 100%;\n    padding: 0;\n    height: 1px;\n    background-color: var(--main-hg-color);\n    left: 0;\n    top: 0;\n  }\n  \n  form {\n    font-size: 12px;\n    display: flex;\n    flex-direction: column;\n  }\n  */\n  form > *:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  \n  input {\n    width: 100%;\n    border: solid 1px var(--main-hg-color);\n    padding: var(--inputPadding);\n    font-weight: bold;\n  }\n  \n  select {\n    width: 100%;\n    border: solid 1px var(--main-hg-color);\n    padding: var(--inputPadding);\n    font-weight: bold;\n  }\n  \n  .textPR {\n    padding-right: 80px;\n  }\n  \n  .backLink {\n    letter-spacing: 1px;\n    position: absolute;\n    top: 25px !important;\n    z-index: 9999;\n    font-weight: bold;\n    color: var(--footer-selected-color) !important;\n    text-transform: uppercase;\n    font-size: 10px;\n    left: 25px;\n  }\n  \n  body form .labelInput {\n    color: #BBBBBB;\n    font-size: 12px;\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .buttonFormLast {\n    font-size: 12px;\n    width: 100%;\n    text-align: center;\n    color: #BBBBBB;\n    font-weight: bold;\n    display: block;\n    margin-top: 13px;\n  }\n  \n  body #content .btnReverse {\n     min-height: 40px;\n     color: var(--footer-selected-color);\n     font-size: 12px;\n     letter-spacing: 1.2px;\n     font-weight: bold;\n     display: flex;\n     justify-content: center;\n     width: 100%;\n     padding: 0;\n     font-family: 'Clother';\n     align-items: center;\n  }\n  \n  .buttonsubmit {\n    font-family: 'Clother';\n    background: rgb(255, 158, 23) !important;\n    color: white !important;\n  }\n  \n  body #content .buttonsubmit svg {\n    margin-top: -4px;\n  }\n  \n  .btnBo{\n    background: rgb(255, 158, 23);\n    color: white;\n    width: 200px;\n  }\n  .btnBo:hover{\n    color: white;\n    background: var(--main-hg-color);\n  }\n  \n  .buttonsubmit:hover{\n    color: white;\n  }\n  .titleHead {\n    font-family: inherit;\n    font-weight: 300;\n    color: var(--main-link-color);\n    padding-top: 70px;\n    top: 0;\n    z-index: 10;\n    right: 0;\n    width: 100vw;\n    animation-duration: 0.30s;\n    animation-name: slideinHead;\n    background: white;\n    max-width: calc(100vw - 50px);\n    margin: 0 auto;\n  \n  }\n  /*\n  .walletPagereverseAnim {\n    left: 25px !important;\n  }\n  \n  @keyframes slideinHead {\n    from {\n      width: 0;\n    }\n  \n    to {\n      width: 100vw;\n    }\n  }\n  \n  \n  body .Wallet {\n    padding-top: 23px;\n  }\n  \n  .titleHead:after {\n    content: '';\n    width: 100vw;\n    left: 0;\n    bottom: 0;\n    height: 30px;\n    background: linear-gradient(to bottom,rgba(255,255,255,0.1),rgba(255,255,255,0));\n    position: absolute;\n  }\n  \n  \n  .container__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: -webkit-fill-available;\n  }\n  \n  .container__list li {\n    list-style: none;\n    margin: inherit;\n    padding: 21px 0;\n    justify-content: space-between;\n    display: flex;\n    border-bottom: 0.5px solid var(--footer-separator-color);\n    align-items: center;\n    min-height: 64.59px;\n    position: relative;\n  }\n  \n  .container__list li:last-child {\n    border: initial;\n    margin-bottom: 29px;\n  }\n  \n  .container__list li a {\n    color: var(--footer-selected-color);\n    text-transform: uppercase;\n    font-size: 13px;\n    letter-spacing: 0.65px;\n    display: flex;\n    align-items: center;\n    top: 0;\n    right: -25px;\n    bottom: 0;\n    left: -25px;\n    width: 100%;\n  }\n  \n  .productHeader {\n    padding-top: 0 !important;\n  }\n  \n  \n  body {\n    overflow-y: hidden;\n  }\n  \n  .btnReverse {\n    background:white !important;\n    color: var(--main-hg-color) !important;\n    border: 1px solid var(--main-hg-color);\n  }\n  \n  .inputError {\n    border: solid 1px red;\n    box-shadow: 0px 0px 5px 2px rgba(255, 0, 0, 0.6);\n  }\n  \n  \n  @media screen and (-webkit-min-device-pixel-ratio:0) and (max-device-width:1024px) {\n    input[type=\"color\"],\n    input[type=\"date\"],\n    input[type=\"datetime\"],\n    input[type=\"datetime-local\"],\n    input[type=\"email\"],\n    input[type=\"month\"],\n    input[type=\"number\"],\n    input[type=\"password\"],\n    input[type=\"search\"],\n    input[type=\"tel\"],\n    input[type=\"text\"],\n    input[type=\"time\"],\n    input[type=\"url\"],\n    input[type=\"week\"],\n    select:focus,\n    textarea {\n      font-size: 16px;\n    }\n  }\n  \n  .longLabel {\n    display: block;\n  }\n  .shortLabel {\n    display: none;\n  }\n  \n  \n  @media only screen and (max-width: 800px) {\n    .longLabel {\n      display: none;\n    }\n    .shortLabel {\n      display: block;\n    }\n  }\n  \n  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
